<template>
  <div class="ftpItem">
    <div class="item auItem2">
      <el-form :model="Item" ref="ftpForm" :rules="ftpRule" label-width="80px" class="userForm">
        <el-form-item label="FTP地址" prop="url">
          <el-input v-model="Item.url" placeholder="FTP地址"></el-input>
        </el-form-item>
        <el-form-item label="登录账号" prop="account">
          <el-input v-model="Item.account" placeholder="登录账号"></el-input>
        </el-form-item>
        <el-form-item label="登录密码" prop="password">
          <el-input v-model="Item.password" placeholder="登录密码" show-password></el-input>
        </el-form-item>
        <el-form-item label="端口号" prop="port">
          <el-input v-model="Item.port" placeholder="端口号"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="center">
      <el-button type="primary" @click="submit" size="small" :loading="loading">确认保存</el-button>
      <a href="javascript:;" @click="closeDialog" class="callback">返回</a>
    </div>
  </div>
</template>

<script>
import eventBus from '../../common/eventBus.js'
export default {
  name: 'ftpItem',
  props: ['model', 'dialogFormVisible'],
  data () {
    return {
      loading: false,
      ftpRule: {
        url: [
          { required: true, message: '请输入FTP地址', trigger: 'blur' }
        ],
        account: [
          { required: true, message: '请输入登录账号', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入登录密码', trigger: 'blur' }
        ],
        port: [
          { required: true, message: '请输入端口号', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    Item: {
      get () {
        return this.model
      }
    }
  },
  methods: {
    submit() {
      this.$refs.ftpForm.validate(valid => {
        if (valid) {
          this.loading = true
          var action = 'ftpAdd'
          if (this.Item.id) {
            action = 'ftpEdit'
          }
          this.saveOrUpdate(action)
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    saveOrUpdate(action) {
      let ftp = JSON.stringify(this.Item)
      this.$http({
        method: 'post',
        url: `/dmc/ftp/${action}`,
        headers: {
          'Content-Type': 'application/json;charset=UTF-8'
        },
        data: ftp
      }).then(r => {
        let { retMsg, retCode } = r.data
        if (retCode === '0') {
          this.$message.success(retMsg)
          this.$refs.ftpForm.resetFields()
          this.$emit('ftpList')
          this.closeDialog()
        } else {
          if (retMsg === '用户未登录！') {
            eventBus.$emit('logout')
          }
          this.$message.warning(retMsg)
        }
        this.loading = false
      })
    },
    closeDialog() {
      this.$emit('onDialogVisible', false)
    }
  },
  watch: {
    dialogFormVisible(value) {
      if (!value) {
        this.$refs.ftpForm.resetFields()
      }
    }
  }
}
</script>

<style lang="less">
.ftpItem{
  position: relative;
  p{
    padding: 0 10px;
    border-top:1px solid #ddd;
    text-align: justify;
  }
  .item{
    padding: 0px 0px 10px;
    min-height: 110px;
    margin-bottom: 10px;
  }
  .auItem2{
    padding-top: 10px;
    .el-form-item__label{
      text-align: left;
    }
    .vcode{
      width: 50%;
      input{
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }
    }
    a{
      display: inline-block;
      width: 80px;
      height: 40px;
      background-color: #f55d54;
      text-align: center;
      vertical-align: bottom;
    }
  }
  .center{
    text-align: center;
    a{
      width: 60px;
      border-radius: 3px;
      font-size: 12px;
      background-color: #f56c6c;
      display: inline-block;
      padding:8px 10px;
      color: #fff;
      margin:0 25px;
    }
    .save{
      background-color: #409eff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/usercenter/ftpItem.vue